import { useCallback, useRef, useState } from 'react';

const empty = () => ({ text: '', files: [] });

// Session storage contains only the draft and file references, never file bodies.
// The server reauthorizes these paths before reading anything.
export default function useProjectChatDraft(identityKey, caseid, conversationId) {
  const memory = useRef(new Map()).current;
  const key = conversationId ? JSON.stringify([identityKey || '', caseid, conversationId]) : null;
  const storageKey = `project-chat-draft:${key}`;
  const [current, setCurrent] = useState({ key: null, value: empty() });
  let value = current.value;
  if (current.key !== key) {
    value = memory.get(key) || empty();
    if (identityKey && key) {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey));
        if (saved && typeof saved.text === 'string' && saved.text.length <= 12000 &&
            Array.isArray(saved.files) && saved.files.length <= 8 &&
            saved.files.every(file => typeof file.path === 'string' && file.path.length <= 4096)) value = saved;
      } catch (_) { /* An unavailable browser store does not block composing. */ }
    }
    setCurrent({ key, value });
  }
  const update = useCallback(change => setCurrent(previous => {
    if (!key || previous.key !== key) return previous;
    const next = typeof change === 'function' ? change(previous.value) : change;
    memory.set(key, next);
    if (memory.size > 50) memory.delete(memory.keys().next().value);
    if (identityKey) {
      try { sessionStorage.setItem(storageKey, JSON.stringify(next)); } catch (_) { /* Keep the in-memory draft. */ }
    }
    return { key, value: next };
  }), [key, identityKey, storageKey, memory]);
  return [value, update];
}
